import gql from 'graphql-tag';

import conversationFragment from '../fragments/conversationFragment';

export const mutationCreateConversation = gql`
  mutation createConversation (
    $remoteConversationID: ID!
    $prompt: String!
    $conversationOrigin: ConversationOrigin!
  ) {
    createConversation (
      remoteConversationID: $remoteConversationID
      prompt: $prompt
      conversationOrigin: $conversationOrigin
    ) {
      ...conversationFragment
    }
  }
  ${conversationFragment}
`;
export default mutationCreateConversation;
